module.exports = __webpack_public_path__ + "img/mine12.e489b3ad.png";